<!-- Variants that should be displayed outside table (like sizes) -->
<div *ngFor="let key of objectKeys(variants)" class="mb-4">
  <div *ngIf="shouldDisplayOutsideTable(variants[key]?.variant?.label)" class="space-y-2">
    <h3 class="text-sm font-bold text-gray-800 tracking-tight">{{ variants[key]?.variant?.label | titlecase }}</h3>
    <div class="flex flex-wrap gap-2">
      <button *ngFor="let variant of variants[key]?.values" (click)="selectVariant(key, variant)"
        class="px-4 py-2 text-sm font-medium border border-gray-300 rounded-md cursor-pointer transition-all duration-200 hover:border-gray-400 hover:bg-gray-50"
        [class.bg-orange-500]="selectedVariants[key]?.id == variant?.id"
        [class.text-white]="selectedVariants[key]?.id == variant?.id"
        [class.border-orange-500]="selectedVariants[key]?.id == variant?.id"
        [class.hover:bg-orange-600]="selectedVariants[key]?.id == variant?.id"
        [class.hover:border-orange-600]="selectedVariants[key]?.id == variant?.id">
        {{ getCleanValue(variant?.value, variants[key]?.variant?.label) }}
      </button>
    </div>
  </div>
</div>

<!-- Table format for other variants -->
<div *ngIf="hasTableVariants()" class="space-y-3">
  <h3 *ngIf="hasRealTechnicalVariants()" class="font-bold text-sm sm:text-base text-gray-800">{{ 'Dane techniczne:' | translate }}</h3>
  <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
  <div class="divide-y divide-gray-200">
    <div *ngFor="let key of getTableVariantKeys()" class="flex">
      <div class="flex-1 px-4 py-3 border-r border-gray-200 flex items-center">
        <h3 class="text-xs sm:text-sm font-medium text-gray-800 leading-relaxed">{{ variants[key]?.variant?.label | titlecase }}
        </h3>
      </div>
      <div class="flex-1 px-4 py-3">
        <div class="flex flex-col gap-2">
          <div *ngFor="let variant of variants[key]?.values" class="flex items-center gap-2 group">
            <!-- Label -->
            <span class="text-sm font-medium text-gray-700">
              {{ getCleanValue(variant?.value, variants[key]?.variant?.label) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div></div>
